<div class="pt-3">
  <div class="logo">
    <img src="assets/logo_oxy.png" alt="Logo">
  </div>
  <nav class="main-menu">
    <ul>
      <li *ngIf="hasRole('cde')">
        <a routerLink="/dashboards/home" routerLinkActive="active">
          <img src="assets/icons/dashboard-icon.svg" alt="">
          <span>Dashboard</span>
        </a>
      </li>
      <li *ngIf="hasRole('cde')">
        <button class="dropdown" [class.active]="isExpanded('charts')" (click)="toggleSection('charts')">
          <img src="assets/icons/info-icon.svg" alt="">
          <span>Gráficos y Estadísticas</span>
        </button>
        <ul *ngIf="isExpanded('charts')">
          <li>
            <a routerLink="/customer-report-home" routerLinkActive="active">Informes para clientes</a>
          </li>
          <li>
            <a routerLink="/saved-views-report" routerLinkActive="active">Mis Vistas Guardadas</a>
          </li>
        </ul>
      </li>
      <li *ngIf="hasRole('cde')">
        <button class="dropdown" [class.active]="isExpanded('mantenedores')" (click)="toggleSection('mantenedores')">
          <img src="assets/icons/toolbox-icon.svg" alt="">
          <span>Mantenedores</span>
        </button>
        <ul *ngIf="isExpanded('mantenedores')">
          <li>
            <a routerLink="/clients" routerLinkActive="active">Clientes</a>
          </li>
          <li>
            <a routerLink="/maintenance-types" routerLinkActive="active">Tipo Mantención</a>
          </li>
          <li>
            <a routerLink="/containers" routerLinkActive="active">Envase</a>
          </li>
          <li>
            <a routerLink="/container-types" routerLinkActive="active">Tipo de Envase</a>
          </li>
          <li>
            <a routerLink="/acceptance-criteria" routerLinkActive="active">Criterios</a>
          </li>
          <li>
            <a routerLink="/tasks" routerLinkActive="active">Tareas</a>
          </li>
          <li>
            <a routerLink="/maintenances" routerLinkActive="active">Mantenciones</a>
          </li>
        </ul>
      </li>
      <li *ngIf="hasRole('cde')">
        <button class="dropdown" [class.active]="isExpanded('notificaciones')" (click)="toggleSection('notificaciones')">
          <img src="assets/icons/toolbox-icon.svg" alt="">
          <span>Notificaciones</span>
        </button>
        <ul *ngIf="isExpanded('notificaciones')">
          <li>
            <a routerLink="/approval-notifications" routerLinkActive="active">Notificaciones Aprobador</a>
          </li>
          <li>
            <a routerLink="/requester-notifications" routerLinkActive="active">Notificaciones Solicitante</a>
          </li>
          <li>
            <a routerLink="/alert-settings" routerLinkActive="active">Configuración de Alertas</a>
          </li>
        </ul>
      </li>
      <li *ngIf="canAccess('iniciar-turno')">


        <button class="button button-success button-sm checkturn-button" (click)="openModal()">
          <img class="mr-2" src="assets/icons/checkturn-icon.svg" alt=""> Iniciar Turno
        </button>
      </li>
  <li *ngIf="canAccess('mis-novedades') || canAccess('dcs') || canAccess('cloruro-ferrico') || canAccess('salmuera-i') || canAccess('salmuera-ii') || canAccess('comprension') || canAccess('electrolizadores') || canAccess('subestacion') || canAccess('mov-prod')">
        <button class="dropdown" [class.active]="isExpanded('novedades')" (click)="toggleSection('novedades')">
          <img src="assets/icons/factory-icon.svg" alt="">
          <span>Novedades</span>
        </button>
        <ul *ngIf="isExpanded('novedades')">
          <li *ngIf="canAccess('mis-novedades')">
            <a routerLink="/mis-novedades" routerLinkActive="active">Mis novedades</a>
          </li>
          <li *ngIf="canAccess('cloruro-ferrico')">
            <a routerLink="/cloruro-ferrico" routerLinkActive="active">Cloruro férrico</a>
          </li>
          <li *ngIf="canAccess('salmuera-i')">
            <a routerLink="/salmuera-i" routerLinkActive="active">Salmuera I</a>
          </li>
          <li *ngIf="canAccess('salmuera-ii')">
            <a routerLink="/salmuera-ii" routerLinkActive="active">Salmuera II</a>
          </li>
          <li *ngIf="canAccess('comprension')">
            <a routerLink="/comprension" routerLinkActive="active">Comprensión</a>
          </li>
          <li *ngIf="canAccess('electrolizadores')">
            <a routerLink="/electrolizadores" routerLinkActive="active">Electrolizadores</a>
          </li>
          <li *ngIf="canAccess('subestacion')">
            <a routerLink="/subestacion" routerLinkActive="active">Subestación</a>
          </li>
          <li *ngIf="canAccess('mov-prod')">
            <a routerLink="/mov-prod" routerLinkActive="active">Movimiento de productos</a>
          </li>
          <li *ngIf="canAccess('dcs')">
            <a routerLink="/dcs" routerLinkActive="active">DCS</a>
          </li>
        </ul>
      </li>
      <li *ngIf="canAccess('daily-shift') || canAccess('shift-report') || canAccess('historical-shift')">
        <button class="dropdown" [class.active]="isExpanded('gestion_turnos')" (click)="toggleSection('gestion_turnos')">
          <img src="assets/icons/manager-icon.svg" alt="">
          <span>Gestión de turnos</span>
        </button>
        <ul *ngIf="isExpanded('gestion_turnos')">
          <li *ngIf="canAccess('daily-shift') && isDailyShiftOpen">
            <a routerLink="/daily-shift" routerLinkActive="active">Novedades Diarias Jefe de Turno</a>
          </li>
          <li *ngIf="canAccess('shift-report')">
            <a routerLink="/shift-report" routerLinkActive="active">{{ getShiftReportMenuLabel() }}</a>
          </li>
          <li *ngIf="canAccess('historical-shift')">
            <a routerLink="/historical-shift" routerLinkActive="active">Turnos históricos</a>
          </li>
        </ul>
      </li>

      <!-- nuevo -->
       <li *ngIf="canAccess('mis-novedades')">
        <button class="dropdown" [class.active]="isExpanded('gestion_usuarios')" (click)="toggleSection('gestion_usuarios')">
          <img src="assets/icons/bolt-icon.svg" alt="">
          <span>Gestión de usuarios</span>
        </button>
        <ul *ngIf="isExpanded('gestion_usuarios')">
          <li>
            <a routerLink="/user-management" routerLinkActive="active">Usuarios</a>
          </li>
          
        </ul>
      </li>


      <li>
        <a href="#" (click)="logout()">
          <i class="fas fa-sign-out-alt ml-2"></i>
          <span>Cerrar sesión</span>
        </a>
      </li>      
    </ul>
  </nav>

  <div *ngIf="modalState === true" class="modal startShift-modal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 *ngIf="modalInfo === false" class="modal-title text-primary-500">Iniciar turno</h4>
          <h5 *ngIf="modalInfo === true" class="modal-title text-primary-500">Turno iniciado correctamente</h5>
          <button type="button" class="close" aria-label="Close" (click)="closeModal()">X</button>
        </div>
        <div *ngIf="modalInfo === false" class="modal-body text-center">
          @if(isConflictive){
            <p>Antes de abrir un nuevo turno debe emitir informe pendiente</p>
          }@else {
            <p>¿Desea iniciar el turno correspondiente?</p>
          }
        
          @if(!isConflictive){
            <div class="form-group mt-3">
              <label for="horaTurno"><strong>Hora de inicio:</strong></label>
              <input
                id="horaTurno"
                type="time"
                class="form-control"
                [(ngModel)]="shiftInfo.hora"
              />
            </div>
          }
        </div>
        
        <div *ngIf="modalInfo === true" class="modal-body">
          <ul class="list">
            <li>
              <strong>Jefe de turno:</strong> {{ shiftInfo.jefeTurno }}
            </li>
            <li>
              <strong>Rut:</strong> 11.111.111-1
            </li>
            <li>
              <strong>Fecha:</strong> {{ shiftInfo.fecha }}
            </li>
            <li>
              <strong>Hora:</strong> {{ shiftInfo.hora }}
            </li>
          </ul>
        </div>
        <div *ngIf="modalInfo === false" class="modal-footer">
          <button type="button" class="button button-outlined-primary button-sm mr-2" (click)="closeModal()">Cancelar</button>
          @if(!isConflictive){
            <button type="button" class="button button-success button-sm" (click)="iniciarSesion()">Si, iniciar</button>
          }
        </div>
        <div *ngIf="modalInfo === true" class="modal-footer">
          <button type="button" class="button button-outlined-primary button-sm mr-2" (click)="closeModal()">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</div>
